import React, { Fragment, useContext, useRef } from "react";
import { Dialog, Transition } from "@headlessui/react";
import AppContext from "../../context/AppContext";
import { toast } from "../../utils/toast";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { FaSignOutAlt } from "react-icons/fa";
import translations from "./Translations";
import CommonButton from "./CommonButton";
import ModalCloseButton from "./ModalCloseButton";
export default function Logout({ showModal, setShowModal, isNavbarOpen }) {
  const cancelButtonRef = useRef(null);
  const { theme, langMode, setWorkflowId, setSelectedOption, setRcOrgName, setRcOrgId, setRcWorkflowId, setRcWorkflowName } = useContext(AppContext);
  const navigate = useNavigate();

  const handleConfirmLogout = () => {
    window.localStorage.removeItem("isLoggedIn");
    setShowModal(false);
    const cookies = Cookies.get();
    for (const cookie in cookies) {
      Cookies.remove(cookie);
    }
    sessionStorage.clear();
    localStorage.removeItem("userDetails");
    localStorage.removeItem("accessToken");
    localStorage.removeItem("activeTab");
    localStorage.removeItem("selectedOrgName");
    localStorage.removeItem("selectedOrgId");
    localStorage.removeItem("selectedFields");
    localStorage.removeItem("FCMToken");
    localStorage.removeItem("RcselectedOrgId");
    localStorage.removeItem("RcselectedOrgName");
    localStorage.removeItem("departmentId");
    localStorage.removeItem("projectId");
    localStorage.removeItem("userManageTableView");
    localStorage.removeItem("activityId")
    localStorage.removeItem('formdepartmentId')
    setRcOrgName('');
    setRcOrgId('')
    setSelectedOption(""); // Reset selectedOption in context
    setWorkflowId(""); // Reset workflowId in context
    setRcWorkflowId("");
    setRcWorkflowName("");
    localStorage.removeItem("selectedActivity");
    navigate("/");
    toast.success(translations[langMode].logout);
  };

  const handleCancelLogout = () => {
    setShowModal(false);
  };

  return (
    <Transition.Root show={showModal} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-50"
        initialFocus={cancelButtonRef}
        onClose={() => setShowModal(false)}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-50 transition-opacity z-50" />
        </Transition.Child>
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 text-center">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <Dialog.Panel
              data-testid="logout-confirmation-modal"
              className={`z-50 transform overflow-hidden rounded-2xl border transition-all w-[92vw] max-w-md p-0 shadow-[0_20px_45px_-20px_rgba(0,0,0,0.45)] ${theme === "dark" ? "bg-gray-800 text-white border-gray-700" : "bg-white border-slate-200"
                }`}
            >
              <div className="relative px-5 pt-5 pb-2">
                <ModalCloseButton
                  className={`absolute top-4 right-4 transition-transform duration-150 hover:scale-105 ${theme === "dark" ? "text-gray-300 hover:bg-gray-700" : "text-gray-600 hover:bg-gray-100"
                    }`}
                  onClick={handleCancelLogout}
                  ref={cancelButtonRef}
                />
                <div className="flex flex-col items-center text-center">
                  <div className={`inline-flex h-14 w-14 items-center justify-center rounded-full ${theme === "dark" ? "bg-blue-900/40 text-blue-300" : "bg-blue-50 text-blue-600"
                    }`}>
                    <FaSignOutAlt className="h-7 w-7" />
                  </div>
                  <Dialog.Title className="mt-4 text-lg font-semibold leading-6">
                    {translations[langMode].Logout}
                  </Dialog.Title>
                  <p className={`mt-2 text-sm leading-5 ${theme === "dark" ? "text-gray-300" : "text-gray-600"}`}>
                    {translations[langMode].loogoutMsg}
                  </p>
                </div>
              </div>
              <div className={`px-5 pb-5 pt-3`}>
                <div className={`flex flex-col-reverse gap-3 sm:flex-row sm:justify-center ${langMode === "ar" ? "sm:flex-row-reverse" : ""}`}>
                  <CommonButton colorIntent="danger"
                    variant="danger"
                    onClick={handleCancelLogout}
                    tooltipText={translations[langMode].cancelandstay}
                    tooltipPosition="top"
                    data-testid="logout-cancel"
                    className="!w-full sm:!w-auto !justify-center !rounded-xl !px-6"
                  >
                    {translations[langMode].cancel}
                  </CommonButton>
                  <CommonButton colorIntent="warning"
                    variant="primary"
                    tooltipPosition="top"
                    tooltipText={translations[langMode].confirmandlogout}
                    onClick={handleConfirmLogout}
                    data-testid="logout-confirm"
                    className="!w-full sm:!w-auto !justify-center !rounded-xl !px-6"
                  >
                    {translations[langMode].Logout}
                  </CommonButton>
                </div>
              </div>
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
